import { useCallback } from 'react';
import {
  AnalyticsEventLabels,
  AnalyticsEventsMap,
  type TrackCoverSheetTaggingEvent,
} from 'src/modules/analytics/useTrackAnalytics/domains/coverSheet/events';
import { useTrackEvent } from 'src/modules/analytics/useTrackAnalytics/useTrackAnalytics';

export function useTrackCoverSheetAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackCoverSheetTaggingEvent, extra?: Record<string, unknown>) => {
      const eventLabel = AnalyticsEventLabels[event];
      const eventInfo = AnalyticsEventsMap[event];
      trackEvent(eventLabel, { ...eventInfo, ...extra });
    },
    [trackEvent],
  );
}
